import React from "react";

class RuleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: "126" };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    // pass this.state.value into a function passed as a prop that updates ECA state
    this.props.onSubmit(this.state.value);
    event.preventDefault();
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <input
          type="text"
          value={this.state.value}
          style={{ width: "30px" }}
          onChange={this.handleChange}
        />
        <input type="submit" value="submit" />
      </form>
    );
  }
}

export default RuleForm;
